'use strict';

/**
 * @ngdoc function
 * @name ribytRsvpApp.controller:IntroductionCtrl
 * @description
 * # IntroductionCtrl
 * Controller of the ribytRsvpApp
 */
/* global notificationService */
angular.module( 'ribytRsvpApp' )
    .controller( 'IntroductionCtrl', ['$scope', '$rootScope', '$q', 'moment', '$http', '$window', 'ENV', '$sessionStorage', '$state', 'variableSubstitution', '$timeout', 'messageDictionary', function introductionCtrl ( $scope, $rootScope, $q, moment, $http, $window, ENV, $sessionStorage, $state, $variableSubstitution, $timeout, $messageDictionary ) {
        // currentRsvpStatus is used to hide view logic until we know for sure what rsvp value definitely will be
        // this prevents flash of content that may not be relevant
        $rootScope.currentRsvpStatus = $rootScope.currentRsvpStatus ? $rootScope.currentRsvpStatus : null; // update this with correct value after we want to enable the view
        $rootScope.bannerImage = true;
        $rootScope.isTicketPage = false;
        $rootScope.isLandingPage = true;
        // byt list
        $scope.bytList = [];

        // scope funcs
        $scope.accept = accept;
        $scope.decline = decline;

        // init invite var
        var invite = {}; // will get later with a promise

        if ( $state.current.name !== 'main.complete' ) {
            $rootScope.currentTab = 'introduction';
        } else {
            $rootScope.currentTab = 'welcome';
        }

        function getData () {
            init( ) // get the final invite, possibly via async call
                .then( function render ( finalInvite ) {
                    invite = finalInvite;
                    // set the rootscope.rsvpProcess variable. If it doesn't exist, that means they just landed.
                    // if they said yes or no, they are at welcome
                    if ( !_.has( $rootScope, 'rsvpProcess' ) ) {
                        _.set( $rootScope, 'rsvpProcess', 'introduction' );
                    } else if ( invite.rsvp === 'y' || invite.rsvp === 'n' ) {
                        _.set( $rootScope, 'rsvpProcess', 'welcome' );
                    }

                    $rootScope.rsvp = invite.rsvp;

                    // Get needed invite data
                    $scope.inviteData = getInviteData( invite );
                    if ( !invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToRSVP && invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateTo ) {
                        invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToRSVP = invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateTo;
                    }
                    if ( !invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToPersonal && invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateTo ) {
                        invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToPersonal = invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateTo;
                    }
                    var allowEditToDateRSVP = invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToRSVP && moment.tz( invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToRSVP.split( '+' )[0], invite.eventID.location.timezone ).isAfter( moment() );
                    var allowEditToDatePersonal = invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToPersonal && moment.tz( invite.experienceID.RSVPDetails.datetimeGuestIsAbleToUpdateToPersonal.split( '+' )[0], invite.eventID.location.timezone ).isAfter( moment() );

                    $rootScope.allowEditPersonalInfo = invite.experienceID.RSVPDetails.isGuestCanUpdatePersonalInfo && allowEditToDatePersonal;
                    $rootScope.allowEditRSVP = invite.experienceID.RSVPDetails.isGuestCanUpdateRSVP && allowEditToDateRSVP;

                    // Create byt list
                    $scope.bytList = createBytList( invite );

                    // if there is some discrepancy with the back button
                    // redirect state to the rsvpProcess variable only allow introduction and welcome here
                    if ( !_.includes( ['', null, undefined, 'introduction', 'welcome'], invite.rsvpProcess ) ) {
                        // leave it alone but set $root tab to null
                        $rootScope.currentTab = null;
                    }

                    // OK, Now we are ready to enable the view, we have the correct invite data
                    $rootScope.currentRsvpStatus = invite.rsvp; // enable the overall view by setting this variable

                    $scope.agreementEnabled = _.get( ENV, 'featureToggles.agreement', [] ).indexOf( _.get( invite, 'parentID.id' ) ) !== -1;
                    if ( _.get( invite, 'rsvp' ) === 'p' && _.get( invite, 'experienceID.landingPageCustomization.enabled' ) === false ) {
                        accept();
                    }
                } )
                .catch( function err ( error ) {
                    if ( error ) {
                        notificationService.error( $messageDictionary.error.completeRSVPIssue );
                    }
                } );
        }
        getData();

        // Init stuff
        function init ( ) {
            invite = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );

            return $q( function ( resolve, reject ) {
                /**
                 * First, check if that state name is complete since we share this controller and
                 * view. If it's complete and the rsvp is p, send them back to the real
                 * introduction page as they should not see this page.
                 */
                if (
                    _.get( $state, 'current.name' ) === 'main.complete' &&
                    $rootScope.isFinishedRSVPProcess( invite ) &&
                    _.get( invite, 'rsvp' ) === 'p'
                ) {
                    // required for receive callback action on update status after Edit. CON-911
                    $rootScope.hasSetRSVPToYes = false;
                    $rootScope.setRSVPToYes( invite, function rsvpYCallback ( error, response ) {
                        if ( error ) {
                            console.log( error );
                            return reject( $messageDictionary.error.completeRSVPIssue );
                        }

                        invite.rsvp = 'y'; // manually set to y on success and use session invite
                        invite.rsvpProcess = 'welcome'; // manually set to y on success and use session invite
                        var tempInvite = $rootScope.decryptInvite( response.data.data );
                        if ( tempInvite.rsvp === 'w' ) {
                            invite.rsvp = 'w';
                        }

                        return resolve( invite );
                    } );
                } else {
                    return resolve( invite );
                }
            } );
        }

        // Get invite data for scope
        function getInviteData ( invite ) {
            var data = {
                'landingPageCustomization': invite.experienceID.landingPageCustomization && invite.experienceID.landingPageCustomization.enabled ? invite.experienceID.landingPageCustomization : false,
                'eventName': ( _.get( invite, 'experienceID.isGroupNamePriority' ) ) ? _.get( invite, 'experienceID.name', '' ) : _.get( invite, 'eventID.name', '' ),
                'acceptButtonText': _.get( invite, 'experienceID.RSVPDetails.acceptButtonText', $messageDictionary.general.acceptButtonText ),
                'declineButtonText': _.get( invite, 'experienceID.RSVPDetails.declineButtonText', $messageDictionary.general.declineButtonText ),
                'rsvp': _.get( invite, 'rsvp' ),
                'type': _.get( invite, 'type' ),
                'acceptMessage': _.get( invite, 'experienceID.RSVPDetails.acceptMessage', $messageDictionary.general.acceptGuestMessage ),
                'declineMessage': _.get( invite, 'experienceID.RSVPDetails.declineMessage', $messageDictionary.general.declineGuestMessage ),
                'acceptMessageCompanion': _.get( invite, 'experienceID.RSVPDetails.acceptMessageCompanion', $messageDictionary.general.acceptGuestMessage ),
                'declineMessageCompanion': _.get( invite, 'experienceID.RSVPDetails.declineMessageCompanion', $messageDictionary.general.declineGuestMessage ),
                'displayByts': _.get( invite, 'experienceID.RSVPDetails.displayByts', true ),
                'waitlistClosedMessage': _.get( invite, 'experienceID.RSVPDetails.waitlistClosedMessage' ) || 'Registration is closed, you will be added to the waitlist',
                'isWaitlistEnabled': _.get( invite, 'experienceID.RSVPDetails.waitlist' ),
                'isReachedLimit': _.get( invite, 'experienceID.reachedLimit' ),
                'isAllowPublicRSVP': _.get( invite, 'experienceID.RSVPDetails.isAllowPublicRSVP' )
            };
            _.each( data, function each ( value, key ) {
                // send the newest invite data to the substitution service RPT-2548
                if ( key === 'landingPageCustomization' && value ) {
                    value.rightSide = value.rightSide.map( function map ( item ) {
                        if ( item.name === 'Custom Text' ) {
                            item.value = $variableSubstitution.doSubstitutions( item.value, invite );
                        }
                        return item;
                    } );
                    data[key] = value;
                } else {
                    data[key] = $variableSubstitution.doSubstitutions( value, invite );
                }
            } );

            // Setup the location
            var eventLocation = '';
            var locationVenue = _.get( invite.eventID, 'location.venue', null );
            var isLocationExist = _.get( invite, 'eventID.location.formatted_location', null );
            var eventCity, eventState;

            if ( isLocationExist ) {
                eventCity = _.get( invite, 'eventID.location.city', null );
                eventState = _.get( invite, 'eventID.location.state', null );
            }
            if ( eventCity ) {
                eventLocation += eventCity;
            }
            if ( eventState ) {
                eventLocation += ', ' + eventState;
            }
            if ( locationVenue ) {
                eventLocation += ', ' + locationVenue;
            }

            // End location setup

            // Setup the location
            data.location = eventLocation;
            data.digitalLink =  _.get( invite, 'eventID.digitalLink', '' );
            // End location setup

            // Setup dates
            var dateStart = moment.utc( invite.experienceID.dateStart ).format( 'M/D/YYYY' );
            var dateEnd = moment.utc( invite.experienceID.dateEnd ).format( 'M/D/YYYY' );

            if ( dateStart === dateEnd ) {
            // If it's a one day event, just show the day
                _.set( data, 'dateLabel', 'Date: ' );
                _.set( data, 'dates', dateStart );
            } else {
                _.set( data, 'dates', dateStart + ' - ' + dateEnd );
            }
            // End dates

            return data;
        }

        // Create ordered Element list
        function createBytList ( invite ) {
            var bytList = [];
            var experience = _.get( invite, 'experienceID' );

            // Organize the byts for display
            _.sortBy( invite.byts, 'bytID.dateStart' );

            /**
             * Do a bunch of name manipulation
             */
            _.each( invite.byts, function each ( byt ) {
                var bytQuantity = 0;
                var sharedText = '';

            // check the byt quantity for guest or companion
                if ( invite.type === 'i' && byt.qty > 0 ) {
                    bytQuantity = byt.qty;
                } else if ( invite.type === 'g' && ( byt.qtyCompanion > 0 || byt.shareQuantity ) ) {
                /**
                 * If it's a shared byt, then use the actual qty. but add "shared" on display.
                 */
                    if ( byt.shareQuantity ) {
                        sharedText = ' shared';
                        bytQuantity = byt.qty;
                    } else {
                        bytQuantity = byt.qtyCompanion;
                    }
                }

                if ( byt.isEnabled && _.get( byt, 'bytID.isShowOnItinerary', true ) && ( bytQuantity > 0 ) ) {
                    var hideCount = _.has( experience, 'RSVPDetails.hideCount' );

                    switch ( byt.bytID.bytType ) {
                    case 'hotel':
                        var checkIn = moment( experience.dateStart );
                        var checkOut = moment( experience.dateEnd );

                        /**
                         * Check if they want the night to show
                         */
                        if ( hideCount ) {
                            // Hide the count and units on RSVP page
                            if ( experience.RSVPDetails.hideCount ) {
                                bytList.push( byt.bytID.name );
                            } else {
                                // Show the count and units by default
                                bytList.push( byt.bytID.name + ' (' + $rootScope.adjustPlural( checkOut.diff( checkIn, 'days' ) || '1', 'Nights' ) + sharedText + ')' );
                            }
                        } else {
                            // Show the count and units by default
                            bytList.push( byt.bytID.name + ' (' + $rootScope.adjustPlural( checkOut.diff( checkIn, 'days' ) || '1', 'Nights' ) + sharedText + ')' );
                        }
                        break;
                    case 'travel':
                        if ( !byt.qty ) {
                            byt.qty = 1;
                        }
                        if ( hideCount ) {
                            // Hide the count and units on RSVP page
                            if ( hideCount ) {
                                bytList.push( byt.bytID.name );
                            } else {
                                // Show the count and units by default
                                if ( invite.type === 'i' ) {
                                    bytList.push( byt.bytID.name + ' (' + $rootScope.adjustPlural( byt.qty, 'passenger' ) + ')' );
                                } else {
                                    bytList.push( byt.bytID.name + ' (1 passenger)' );
                                }
                            }
                        } else {
                            // Show the count and units by default
                            if ( invite.type === 'i' ) {
                                bytList.push( byt.bytID.name + ' (' + $rootScope.adjustPlural( byt.qty, 'passenger' ) + ')' );
                            } else {
                                bytList.push( byt.bytID.name + ' (1 passenger)' );
                            }
                        }
                        break;
                    case 'activity':
                        if ( _.get( byt, 'bytID.accessControl.bytAccess' ) ) {
                            if ( _.get( experience, 'RSVPDetails.hideCount' ) ) {
                                bytList.push( byt.bytID.name );
                            } else {
                            // depending on whether the accessControl is a ticket or something else, we need to display the correct noun, pluralize it, and display the amount
                                var itemToCount = _.get( byt, 'bytID.accessControl.bytAccess', 'Tickets' );

                                if ( itemToCount === 'Other' && _.get( byt, 'bytID.accessControl.otherDetail' ) ) {
                                    itemToCount = _.get( byt, 'bytID.accessControl.otherDetail', 'Tickets' );
                                }

                                bytList.push( byt.bytID.name + ' (' + $rootScope.adjustPlural( bytQuantity, itemToCount ) + sharedText + ')' );
                            }
                        } else {
                            bytList.push( byt.bytID.name );
                        }
                        break;
                        // This handles activity and bonus
                    case 'ticket':
                        if ( _.get( experience, 'RSVPDetails.hideCount' ) ) {
                            bytList.push( byt.bytID.name );
                        } else {
                            bytList.push( byt.bytID.name + ' (' + byt.qty + ' tickets)' );
                        }
                        break;
                    default:
                        bytList.push( byt.bytID.name );
                    }
                }
            } );
            // End byt organization

            return bytList;
        }

        // Accept button
        function accept () {
            if ( $scope.agreementEnabled && !$scope.agreement ) {
                $scope.showAgreementError = true;
                return;
            }
            $rootScope.accept( invite );
        }

        // Decline button
        function decline () {
            $rootScope.decline( function decline ( err, resp ) {
                if ( err ) {
                    return notificationService.error( $messageDictionary.error.inviteSaveIssue );
                }

                _.set( $sessionStorage, 'invitation', resp.data.data );
                _.set( $rootScope, 'rsvp', 'n' );

                // Send them to the complete page
                $state.go( 'main.complete', {'inviteHash': _.get( $rootScope, 'inviteHash', null )}, { reload: true } );
            } );
        }
    }] );
